import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

const LandingPage: React.FC = () => {
  const { isAuthenticated, loginWithRedirect } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  if (isAuthenticated) {
    return (
      <div className="container">
        <div className="loading-container">
          <div>Redirecting to dashboard...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="landing-page">
        {/* Banner Image */}
        <div style={{
          width: '100%',
          maxWidth: '800px',
          margin: '0 auto 3rem auto',
          textAlign: 'center'
        }}>
          <img 
            src="/images/storage-tank-banner.png" 
            alt="Underground Storage Tank Illustration"
            style={{
              width: '100%',
              height: 'auto',
              borderRadius: 'var(--border-radius-large, 16px)',
              boxShadow: 'var(--shadow-elevated, 0 4px 12px rgba(0, 0, 0, 0.15))',
              filter: 'drop-shadow(0 2px 8px rgba(0, 0, 0, 0.1))'
            }}
          />
        </div>

        <h2>Underground Storage Tank Risk Platform</h2>
        <p>
          Comprehensive risk evaluation and analysis for underground storage tank facilities 
          across the United States. Access detailed facility data, leak histories, and 
          predictive risk scoring for informed decision making.
        </p>
        
        <button 
          className="btn btn-primary" 
          style={{ fontSize: '1.2rem', padding: '1rem 2rem' }}
          onClick={() => loginWithRedirect()}
        >
          Access Platform
        </button>
        
        <div className="features">
          <div className="feature-card">
            <h3>Risk Scoring</h3>
            <p>
              Advanced predictive modeling provides risk scores from 1-10 for all 700,000+ 
              underground storage tank facilities nationwide.
            </p>
          </div>
          
          <div className="feature-card">
            <h3>Interactive Mapping</h3>
            <p>
              Explore facilities through state, county, and location-level mapping with 
              choropleth heat maps and detailed facility pins.
            </p>
          </div>
          
          <div className="feature-card">
            <h3>Comprehensive Data</h3>
            <p>
              Access detailed facility information, tank specifications, leak histories, 
              and regulatory compliance data.
            </p>
          </div>
          
          <div className="feature-card">
            <h3>Address Search</h3>
            <p>
              Search by address with autocomplete functionality and proximity-based 
              facility discovery using advanced geographic calculations.
            </p>
          </div>
          
          <div className="feature-card">
            <h3>Insurance Integration</h3>
            <p>
              Generate exposure sheets and carrier details for insurance underwriting 
              and risk assessment workflows.
            </p>
          </div>
          
          <div className="feature-card">
            <h3>Role-Based Access</h3>
            <p>
              Tailored access levels for administrators, underwriters, brokers, and 
              general users with appropriate feature permissions.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;